import { Button } from '@parentsquare/squarekit/components/ui/button';
import { Input } from '@parentsquare/squarekit/components/ui/input';
import React, { useRef } from 'react';

interface ChatInputProps {
    readonly onSendMessage: (content: string) => void;
    readonly isLoading: boolean;
}

export const ChatInput = ({ onSendMessage, isLoading }: ChatInputProps): React.ReactNode => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleSubmit = (): void => {
        const value = inputRef.current?.value.trim() ?? '';
        if (!value || isLoading) return;

        onSendMessage(value);
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSubmit();
        }
    };

    return (
        <div className="tw:flex tw:w-full tw:items-center tw:gap-2">
            <Input
                ref={inputRef}
                onKeyDown={handleKeyDown}
                disabled={isLoading}
                placeholder="Enter your question"
                maxLength={2000}
                className="tw:flex-1"
            />
            <Button
                variant="primary"
                onClick={handleSubmit}
                disabled={isLoading}
            >
                Send
            </Button>
        </div>
    );
};
